import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b8fc473a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b8fc473a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fc473a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8fc473a')) {
      api.createRecord('b8fc473a', component.options)
    } else {
      api.reload('b8fc473a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b8fc473a&scoped=true&", function () {
      api.rerender('b8fc473a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/member-top-up-list/modules/deduction-detail-dialog/index.vue"
export default component.exports